import { tzPublicAxios } from 'api/axios';
import type { CreateB2BRegistrationRequest } from 'api/requestTypes';
import type { B2BRegistrationResponse } from 'api/responseTypes';
import { buildB2BRegistrationRequestBody } from './buildB2BRegistrationRequestBody';

export type {
  B2BEventType,
  B2BPublicEventCategory,
  B2BRegistrationBase,
  CreateB2BRegistrationRequest,
} from 'api/requestTypes';

export type { B2BRegistrationErrorBody, B2BRegistrationResponse } from 'api/responseTypes';

export { buildB2BRegistrationRequestBody } from './buildB2BRegistrationRequestBody';

const B2B_REGISTER_PATH = '/b2b/register';

/**
 * POST /consumers/b2b/register — public (uses {@link tzPublicAxios}, no Bearer token).
 * 400 / 409 / 429 reject with AxiosError; success is 201 + {@link B2BRegistrationResponse}.
 */
export const postB2BRegistration = async (payload: CreateB2BRegistrationRequest) =>
  (
    await tzPublicAxios.post<B2BRegistrationResponse>(
      B2B_REGISTER_PATH,
      buildB2BRegistrationRequestBody(payload),
    )
  ).data;
